<template>
<el-dialog title="办理离职" :visible.sync="show" width="400px" :before-close="close" :destroy-on-close="true" :close-on-click-modal="false" :close-on-press-escape="false">
	<p style="font-size: 20px;font-weight: 700;padding-left: 10px;margin-bottom: 20px;">为<span style="color: #f00;">{{name}}</span>办理离职</p>
	<el-form :model="form" :rules="rules" ref="form" label-width="100px">
		<el-form-item label="离职日期" prop="day">
			<el-date-picker style="width: 200px;" v-model="form.day" type="date" placeholder="选择日期"></el-date-picker>
		</el-form-item>
	</el-form>
	<div slot="footer" class="dialog-footer">
		<el-button size="small" @click="close">取 消</el-button>
		<el-button size="small" type="primary" @click="submit">确 定</el-button>
	</div>
</el-dialog>
</template>

<script>
export default{
	name:'repdj',
	data() {
		return {
			name:"",
			form:{
				day:""
			},
			rules:{
				day:[{validator:(rule,value,callback)=>{
					if(this.form.day===""){
						callback("请选择起始日期")
					}
					callback()
				},trigger:'blur'}]
			}
		}
	},
	props:{
		user:{
			type:Object
		},
		show:{
			type:Boolean
		}
	},
	watch:{
		show(n){
			if(!n){
				return
			}
			this.name=this.user.name
		}
	},
	methods:{
		close(){
			this.$emit("close",{isrep:false})
		},
		submit(){
			this.$refs.form.validate((e)=>{
				if(!e){
					return
				}
				//整理数据，提交服务器
				let user={
					id:this.user.id,
					etime:this.myfun.date2str(this.form.day),
				}
				this.myfun.Loading()
				const formdata = new FormData()
				formdata.append("user",JSON.stringify(user))
				this.axios.post("data:setout",formdata).then(e=>{
					this.myfun.Loadingclose()
					if(!e)return
					this.myfun.messageSuc("办理成功")
					this.$emit("close",{isrep:true,data:e})
				})
			})
		}
	}
}
</script>

<style>
</style>
